// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__2R-Di","title":"AfterBackImages_title__3_9xq","images":"AfterBackImages_images__EiE3U"};